export const AS_FETCH_RESULTS = 'AS_FETCH_RESULTS'
export const AS_FETCH_RESULTS_REQUESTED = 'AS_FETCH_RESULTS_REQUESTED'
export const AS_FETCH_RESULTS_SUCCESS = 'AS_FETCH_RESULTS_SUCCESS'
export const AS_FETCH_RESULTS_FAILED = 'AS_FETCH_RESULTS_FAILED'
import { polyfill } from 'es6-promise'; 
import "isomorphic-fetch"
polyfill();

const initialState = {
    searchResult: null,
    searchFilters: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case AS_FETCH_RESULTS_SUCCESS:            
            return {
                ...state,
                searchResult: action.searchResult,
                searchFilters: action.filters
            }

        case AS_FETCH_RESULTS_FAILED:
            return {
                ...state,
                error: action.error,
                searchFilters: action.filters
            }
            
        case AS_FETCH_RESULTS_REQUESTED:
            return {
                ...state,
                searchResult: [],
                error: null
            }
        default:
        return state
    }
}
var baseUrl = '/api/search/';

export const fetchResults = (filters) => {
  return dispatch => {
    dispatch({
      type: AS_FETCH_RESULTS_REQUESTED,
    })

    let flts = {
        CancerType : filters.cancerType.id,
        Suburb : filters.location.id,
        SearchEntityType: filters.searchEntityType,
        PublicOnly : filters.publicOnly,
        ChildrenOrYouthServices : filters.childrenAndYouthServices,
        ChildrenOrYouthTeams : filters.childrenAndYouthTeams,
        TreatmentTypes: filters.treatmentTypes.map((e)=> e.Name).toString(),
        SpecialistGroups: filters.doctorTypes.filter(t => t.checked).map(t => t.Name).toString(),
        SpecialistTypes: filters.doctorTypes.filter(t => !t.checked).map(t => t.DoctorTypes.filter(t => t.checked).map(t => t.Name).toString()).filter(t => !!t).toString(),
        language: filters.language ? filters.language.id : '',
        gender: filters.gender ? filters.gender.id : ''
    }

    fetch(baseUrl + 'as', {
        credentials: 'include',
        method: 'POST', // or 'PUT'
        headers:{
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(flts)
      }).then(res => {
        if(!res.ok && res.status != 400)
        {
          throw Error(res.statusText);
        }
        return res.json();
      })
      .then(response => {
        if(response.Message){
          throw Error(response.Message);
        }
        dispatch({
          type: AS_FETCH_RESULTS_SUCCESS,
          searchResult: response,
          filters: filters
        })
      })
      .catch(error => {
        dispatch({
          type: AS_FETCH_RESULTS_FAILED,
          error: error.message,
          filters: filters
        })
      });
  }
}